import { useParams, Outlet, useNavigate } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import OrganizationSection from '_/common/components/layout/OrganizationSection';
import DocumentTitle from '_/hooks/DocumentTitle';
import { useOrganization } from '_/hooks/useOrganizations';
import React, { ReactElement, useEffect } from 'react';

function SelectedOrg(): ReactElement {
  const params = useParams({ strict: false }) as Partial<{ orgSlug: string }>;
  const orgSlug = params.orgSlug || '';
  const { data: selectedOrg, isLoading: isFetchingOrganization } = useOrganization(orgSlug);
  const navigate = useNavigate();

  // Redirect from UUID to slug
  useEffect(() => {
    if (selectedOrg && orgSlug !== selectedOrg.slug) {
      // Check if orgSlug is a UUID (GUID)
      const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(orgSlug);
      if (isUUID) {
        // Replace the UUID in the current path with the slug
        const currentPath = location.pathname;
        const newPath = currentPath.replace(`/orgs/${orgSlug}`, `/orgs/${selectedOrg.slug}`);
        navigate({ to: newPath, replace: true });
      }
    }
  }, [selectedOrg, orgSlug, navigate]);

  DocumentTitle(`${selectedOrg?.name} :: ${location.pathname.split('/').pop()}`);

  return (
    <OrganizationSection>
      <AsyncPageContainer isLoading={!selectedOrg || isFetchingOrganization}>
        <Outlet />
      </AsyncPageContainer>
    </OrganizationSection>
  );
}

export default SelectedOrg;
